import { messagesLt, type Catalog } from '@smarton-pbx/shared';
import { calls } from './calls';
import { common } from './common';
import { flows } from './flows';
import { insights } from './insights';
import { people } from './people';
import { phone } from './phone';
import { pipeline } from './pipeline';
import { platform } from './platform';
import { queues } from './queues';
import { settings } from './settings';
import { shell } from './shell';
import { texts } from './texts';

/**
 * Lithuanian for the web app: English text as written in the code →
 * Lithuanian, one file per part of the app (common: words many parts use).
 * The server's and the shared forms' messages come from messagesLt.
 * Glossary and style: apps/docs/TRANSLATING.md. Check: npm run i18n:check -w apps/web.
 */
export const areas: Record<string, Catalog> = { common, shell, phone, platform, calls, pipeline, queues, insights, people, flows, settings, texts };

export const lt: Catalog = Object.assign({}, messagesLt, ...Object.values(areas));
